import React from "react"
import AnalyticsCardGrid from "components/Templates/analytics/AnalyticsCardGrid"
import AnalyticsDrawer, {
  AggregationNotAvailable,
} from "components/Templates/analytics/AnalyticsDrawer"
// import AnalyticsDrawer, {
//   AggregationNotAvailable,
// } from "components/Templates/AnalyticsDrawer";
import ContainerSpinner from "components/Templates/ContainerSpinner"
import { useSummaryAllOrderItems } from "graphql/dispatch/dispatch.hooks"

const AnalyticsCard = ({ title, children, intent }) => {
  return (
    <div className="vt-card">
      <h6>{title}</h6>
      <p className={intent && `vt-${intent}`}>{children}</p>
    </div>
  )
}

const SummaryOrderItemDrawer = ({ className, isOpen, setOpen }) => {
  const { data, loading } = useSummaryAllOrderItems(isOpen)

  const s = data?.summaryAllOrders
  return (
    <>
      <AnalyticsDrawer
        title="Summary of Orders and Items"
        isOpen={isOpen}
        onClose={e => setOpen(false)}
      >
        {loading ? (
          <ContainerSpinner />
        ) : data?.summaryAllOrders ? (
          <AnalyticsCardGrid>
            <AnalyticsCard intent="primary" title="Total">
              <div>
                {s?.orderCount || 0}{" "}
                <span className="vt-metric-tag">Orders</span>
              </div>
              <div>
                {s?.itemCount || 0} <span className="vt-metric-tag">Items</span>
              </div>
            </AnalyticsCard>
            <AnalyticsCard intent="primary" title="Placed">
              <div>
                {s?.statusPlaced || 0}{" "}
                <span className="vt-metric-tag">Orders</span>
              </div>
              <div>
                {s?.itemStatusPlaced || 0}{" "}
                <span className="vt-metric-tag">Items</span>
              </div>
            </AnalyticsCard>
            <AnalyticsCard title="Confirmed" intent="warning">
              <div>
                {s?.statusConfirmed || 0}{" "}
                <span className="vt-metric-tag">Orders</span>
              </div>
              <div>
                {s?.itemStatusConfirmed || 0}{" "}
                <span className="vt-metric-tag">Items</span>
              </div>
            </AnalyticsCard>
            <AnalyticsCard title="Ready For Schedule" intent="warning">
              <div>
                {s?.statusReadyForSchedule || 0}{" "}
                <span className="vt-metric-tag">Orders</span>
              </div>
              <div>
                {s?.itemStatusReadyForSchedule || 0}{" "}
                <span className="vt-metric-tag">Items</span>
              </div>
            </AnalyticsCard>
            <AnalyticsCard intent="success" title="Completed">
              <div>
                {s?.statusCompleted || 0}{" "}
                <span className="vt-metric-tag">Orders</span>
              </div>
              <div>
                {s?.itemStatusCompleted || 0}{" "}
                <span className="vt-metric-tag">Items</span>
              </div>
            </AnalyticsCard>
            {/* <AnalyticsCard intent="danger" title="Cancelled By User">
							<div>
								{s?.statusCancelledByUser || 0}{" "}
								<span className="vt-metric-tag">Orders</span>
							</div>
							<div>
								{s?.itemStatusCancelledByUser || 0}{" "}
								<span className="vt-metric-tag">Items</span>
							</div>
						</AnalyticsCard>
						<AnalyticsCard intent="danger" title="Cancelled By Vendor">
							<div>
								{s?.statusCancelledByVendor || 0}{" "}
								<span className="vt-metric-tag">Orders</span>
							</div>
							<div>
								{s?.itemStatusCancelledByVendor || 0}{" "}
								<span className="vt-metric-tag">Items</span>
							</div>
						</AnalyticsCard> */}
          </AnalyticsCardGrid>
        ) : (
          <AggregationNotAvailable />
        )}
      </AnalyticsDrawer>
    </>
  )
}

export default SummaryOrderItemDrawer
